import { useDispatch, useSelector } from 'react-redux'
import { setStep } from '../../../actions/checkout-la-actions'

export default function useStep() {
  const dispatch = useDispatch()
  const step = useSelector(({ step }) => step)
  const setCurrentStep = (s) => {
    dispatch(setStep(s))
  }

  return {
    step,
    setStep: setCurrentStep,
  }
}
